const MILLISECONDS_IN_SECOND = 1000;

const SECONDS_IN_MILLISECOND = 1 / MILLISECONDS_IN_SECOND;
const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
const SECONDS_IN_MONTH = SECONDS_IN_DAY * 30;
const SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;
const SECONDS_IN_YEAR = SECONDS_IN_DAY * 365;

/**
 * @description Набор констант, обозначающих количество секунд в юните
 *              Используется для формирования временных интервалов, например:
 *              const threeDays = 3 * Duration.DAY;
 */
export const Duration = {
  DAY: SECONDS_IN_DAY,
  HOUR: SECONDS_IN_HOUR,
  MILLISECOND: SECONDS_IN_MILLISECOND,
  MINUTE: SECONDS_IN_MINUTE,
  MONTH: SECONDS_IN_MONTH,
  SECOND: 1,
  WEEK: SECONDS_IN_WEEK,
  YEAR: SECONDS_IN_YEAR,
} as const;

/**
 * @description Константа, обозначающая количество миллисекунд в секунде
 *              Используется для преобразования секундного интервала в миллисекундный, например:
 *              const threeDaysInMs = 3 * Duration.DAY * MILLISECONDS;
 */
export const MILLISECONDS = 1000 as const;

export function formatSecondsDuration(seconds: number): string {
  let restOfSeconds = Math.round(seconds);

  const days = Math.floor(restOfSeconds / SECONDS_IN_DAY);
  restOfSeconds %= SECONDS_IN_DAY;

  const hours = Math.floor(restOfSeconds / SECONDS_IN_HOUR);
  restOfSeconds %= SECONDS_IN_HOUR;

  const minutes = Math.floor(restOfSeconds / SECONDS_IN_MINUTE);
  restOfSeconds %= SECONDS_IN_MINUTE;

  const segments = [
    [days, 'd.'],
    [hours, 'h.'],
    [minutes, 'm.'],
    [restOfSeconds, 's.'],
  ] as const;

  return segments
    .filter(([value, suffix]) => value > 0 || suffix === 's.')
    .map((segment) => segment.join(''))
    .join(' ');
}
